import React from 'react';
import { graphql } from 'gatsby';

import MediaFullSectionDS from 'design-system/src/components/organisms/MediaFullSection';
import { getImage } from '../../utils/media';

export default function MediaFullSection({ video, backgroundImage }: any) {
    return (
        <MediaFullSectionDS
            video={{
                ...video,
                poster: getImage(backgroundImage || video.thumbnailUrl || null),
            }}
        />
    );
}

export const query = graphql`
    fragment DatoCmsMediaFullSection on DatoCmsMediaFullSection {
        id
        video {
            ...YoutubeVideo
        }
        backgroundImage {
            ...SourceMedia
            gatsbyImageData(placeholder: BLURRED, width: 1508)
        }
    }
`;
